import { Box, Center, Text } from '@chakra-ui/react'

export const TextDivider = ({
  text,
  height = 24,
  // bg = 'white',
  // darkBg = 'gray.900',
}: {
  text: string
  height?: number
  // bg?: TextProps['bg']
  // darkBg?: string
}) => (
  <Center height={`${height}px`} w="100%" position="relative">
    <Box flex={1} minW={0} h="2px" bg="gray.200" _dark={{ bg: 'gray.700' }} />
    <Text
      px={3}
      // bg={bg}
      fontSize="lg"
      fontWeight={500}
      color="gray.500"
      _dark={{ color: 'gray.200' }}>
      {text}
    </Text>
    <Box flex={1} minW={0} h="2px" bg="gray.200" _dark={{ bg: 'gray.700' }} />
  </Center>
)
